
import { sorter, sortTime } from '@/pages/intelligence/utils/sort';

interface SortParamsType {
  ratioType: 0 | 1
  sortVal: 'desc' | 'asc';
  sortMetric: string;
}
const getMetricValue = (cvm: any, sortParams: SortParamsType) => {
  if (cvm && typeof cvm === 'object') {
    const metricsFir = cvm[sortParams?.sortMetric]
    return metricsFir;
  }
  // const metricFir = metricsFir.find((item: any) => {
  //   return item?.metric === sortParams?.sortMetric;
  // });
  return cvm;
};

export const sortOverviewTableByMetric = (tableData: any[], sortParams: SortParamsType): any[] => {
  if (!Array.isArray(tableData)) {
    return []
  }
  const sortTable = tableData.slice(0);
  if (sortParams?.sortMetric === 'release_time') {
    sortTable.sort((first, second) => {
      const firstVal = first?.game_detail?.release_time;
      const secondVal = second?.game_detail?.release_time;
      return sortParams?.sortVal === 'asc'
        ? sortTime(secondVal, firstVal)
        : sortTime(firstVal, secondVal);
    });
  } else if (sortParams?.ratioType === 1) {
    sortTable.sort((first, second) => {
      const firstVal = getMetricValue(first, sortParams)?.ratio;
      const secondVal = getMetricValue(second, sortParams)?.ratio;
      return sortParams?.sortVal === 'asc'
        ? sorter(firstVal, secondVal)
        : sorter(secondVal, firstVal);
    });
  } else {
    sortTable.sort((first, second) => {
      const firstVal = getMetricValue(first, sortParams)?.value;
      const secondVal = getMetricValue(second, sortParams)?.value;
      return sortParams?.sortVal === 'asc'
        ? sorter(firstVal, secondVal)
        : sorter(secondVal, firstVal);
    });
  }
  return sortTable;
};

